import get from 'lodash/get'
import { fromJS } from 'immutable'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get onboarded featured content impression (CIID) for a user from Brooklyn.
 * @param {Object} options
 * @param {import('immutable').Map} options.auth
 * @param {String} options.server Brooklyn base URL
 * @param {Number|String} options.uid
 * @returns {Promise<import('immutable').Map>}
 */
export async function getUserContentImpression (options = {}) {
  const { auth, uid, server } = options
  const res = await request
    .get(`${server}/v1/admin/user-content-impression`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .query({ uid })
  const values = get(res, 'body', {})
  return fromJS(values)
}
